import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BBResponseContainer } from '../carrier/response-container';
import { timeout, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RedoProcessingRequest } from './redo-processing-request';

@Injectable()
export class StepRedoService {

  constructor(private http: HttpClient) { }

 public initiateRedoProcess(redoProcessRequest:RedoProcessingRequest): Observable<BBResponseContainer> {
      
      let url = environment.BB_SEQUENCING_SERVICE_URL + 'redo/initiateredo';
        return this.http.post<BBResponseContainer>(url, redoProcessRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
  }
}
